import React from 'react';
export const RealTimeCtx = React.createContext({});
export function useRealTimeCtx() {
    return React.useContext(RealTimeCtx);
}
